import React from 'react';
import ListarPendienteOrdenes from '../../../components/insumos/informes/ListarPendienteOrdenes';
import { PageWrapper } from '../../../components/common';

const ListarPendienteOrdenesPage: React.FC = () => {
  return (
    <PageWrapper>
      <ListarPendienteOrdenes />
    </PageWrapper>
  );
};

export default ListarPendienteOrdenesPage;
